import template from './page.form.html';
import radioInput from './radio-input/form.radio-input.js';
import textInput from './text-input/form.text-input.js';
import checkboxInput from './checkbox-input/form.checkbox-input.js';
import fillableParagraph from './fillable-paragraph/fillable-paragraph';
import _ from 'lodash';

export default angular
  .module('doxy.realtime.components.teleconsent.action.document.page.form', [
    radioInput,
    checkboxInput,
    textInput,
    fillableParagraph,
  ])
  .component('tcForm', {
    //tc-form
    template,
    bindings: {
      classes: '@',
      me: '<',
      data: '<',
      fields: '<',
      element: '<',
      disabled: '<',
    },
    controller: function () {
      this.isFieldDisabled = (field) => {
        return !this.me || field.editBy !== this.me.type;
      };

      this.isAllowed = (fieldName) => {
        const field = this.fields[fieldName];
        if (!field) {
          console.warn(
            `Please check document to have field with name: ${fieldName}`
          );
          return;
        }
        if (!field.if) return true;
        const notAllowed = _.some(field.if, (v, k) => {
          if (this.data[k] != v) return true;
        });

        return !notAllowed;
      };

      this.getFieldWidth = (fieldName) => {
        const field = this.fields[fieldName];
        if (!field || !field.size || parseInt(field.size) === 100)
          return '100%';
        // -2% to add that margin
        return parseInt(field.size) - 2 + '%';
      };
    },
  }).name;
